module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0635.36601ba7.jpg";